

import React, { useEffect, useState } from "react";
import axios from "axios";
import Pagination from "../pagination/Pagination";
import { Link } from "react-router-dom";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import PersonAddAltIcon from "@mui/icons-material/PersonAddAlt";
import { Container } from "@mui/system";
import { FaSearch } from "react-icons/fa";

const Meetings = () => {

  const [designation, setDesignation] = useState("")
    const [meetingPurpose, setMeetingPurpose] = useState("");
    const [topic, setTopic] = useState("");
    const [date, setDate] = useState("");
    const [time, setTime] = useState("");
    const [venue, setVenue] = useState("");
    const [templateType, setTemplateType] = useState("");
    const [file, setFile] = useState("");


    const dist = sessionStorage.getItem("dist");


const onSubmitMeeting = async (e) => {
    e.preventDefault();

    const meetingData = {
        meetingPurpose,
        topic,
        date,
        time,
        venue,
        dist, // <-- add this
    };

    try {
        const response = await axios.post("https://lionsdirectoryapi.emedha.in/notification/api/api/meetings", meetingData);
        alert("Meeting added successfully!");
        setShow(false);
        fetchMeetings();
    } catch (error) {
        console.error("Error adding meeting:", error);
        alert("Failed to add meeting");
    }
};




    const [meetings, setMeetings] = useState([]);

    // Fetch meetings
    
const fetchMeetings = async () => {
  try {
    const dist = sessionStorage.getItem("dist"); // get dist from session
    const response = await axios.post("https://lionsdirectoryapi.emedha.in/notification/api/api/meeting", {
      dist
    });
    setMeetings(response.data);
  } catch (error) {
    console.error("Error fetching meetings:", error);
  }
};

    console.log(meetings)

    useEffect(() => {
        fetchMeetings();
    }, []);


     const [showPerPage] = useState(20);
      const [pagination, setPagination] = useState({
        start: 0,
        end: showPerPage,
      });
    
      const onChangePagination = (start, end) => {
        setPagination({ start: start, end: end });
      };

      const [myMessage, setMessage] = useState("");

        const [show, setShow] = useState(false);
        const handleClose = () => setShow(false);
        const handleShow = () => setShow(true);
        const [show1, setShow1] = useState(false);
        const handleClose1 = () => setShow1(false);

        const userType = sessionStorage.getItem("usertype");
        const userId = sessionStorage.getItem("userId");

 
  return (
    <>
      <Container fluid>
        <h5 className="text-center text-danger">{myMessage}</h5>
      </Container>
      <Button variant="warning" onClick={handleShow}>
        Add<PersonAddAltIcon></PersonAddAltIcon>
      </Button>
      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Add</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <div>
            <form onSubmit={onSubmitMeeting}>
                <input
                    type="text"
                    className="form-control"
                    placeholder="Meeting Purpose"
                    required
                    onChange={(e) => setMeetingPurpose(e.target.value)}
                />
                <br />
                <input
                    type="text"
                    className="form-control"
                    placeholder="Topic"
                    required
                    onChange={(e) => setTopic(e.target.value)}
                />
                <br />
                <input
                    type="date"
                    className="form-control"
                    required
                    onChange={(e) => setDate(e.target.value)}
                />
                <br />
                <input
                    type="time"
                    className="form-control"
                    required
                    onChange={(e) => setTime(e.target.value)}
                />
                <br />
                <input
                    type="text"
                    className="form-control"
                    placeholder="Venue"
                    required
                    onChange={(e) => setVenue(e.target.value)}
                />

<br />
                 
                <br />
                <button type="submit" className="btn btn-success form-control">
                    Submit
                </button>
                <br />
                <button type="reset" className="btn btn-secondary form-control">
                    Reset
                </button>
            </form>
        </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      <FaSearch className="searchIcon"></FaSearch>
      <input
        type="search"
        className="ms-4 search-input-field"
        placeholder="Search.."
        // onChange={searchHandler}
      />
      <div style={{ marginTop: "1rem" }} className="table-container">
        <table className="styled-table table  table-striped table-responsive table-bordered">
        <thead>
                    <tr>
                        <th>ID</th>
                        <th>Meeting Purpose</th>
                        <th>Topic</th>
                        <th>Date</th>
                        <th>Time</th>
                        <th>Venue</th>
                    </tr>
                </thead>
                <tbody>
                    {meetings.length > 0 ? (
                        meetings.map((meeting) => (
                            <tr key={meeting.id}>
                                <td>{meeting.id}</td>
                                <td>{meeting.meetingPurpose}</td>
                                <td>{meeting.topic}</td>
                                <td>{meeting.date}</td>
                                <td>{meeting.time}</td>
                                <td>{meeting.venue}</td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan="6" className="text-center">No meetings found</td>
                        </tr>
                    )}
                </tbody>

        </table>
        <Pagination
          page={showPerPage}
          onChangePagination={onChangePagination}
          total={meetings.length}
        />
      </div>
    </>
  );
};

export default Meetings;
